// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mX8P","comment":"styles_comment__37y8v"};